export default __webpack_public_path__ + "static/product-brief-1d4de49496bc69bf56247c0061c651d9.gif";